import { enumCoreAggregateType } from '@rematter/frontend-lib-api-client';
import { Col, Row, Loading, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import {
  LucideBuilding2,
  LucideFolderTree,
  LucideMapPin,
  LucideUser,
} from 'lucide-react';

import {
  $remoteCoreOutboxEventCounts,
  useCoreAggregateTypeFilter,
} from '../../_state/coreEvents.state';
import { useTranslations } from '../../i18n/useTranslations';

const aggregateTypeConfig = [
  {
    type: enumCoreAggregateType.Organization,
    labelKey: 'organization' as const,
    icon: LucideBuilding2,
    countKey: 'organization' as const,
  },
  {
    type: enumCoreAggregateType.User,
    labelKey: 'user' as const,
    icon: LucideUser,
    countKey: 'user' as const,
  },
  {
    type: enumCoreAggregateType.Facility,
    labelKey: 'facility' as const,
    icon: LucideMapPin,
    countKey: 'facility' as const,
  },
  {
    type: enumCoreAggregateType.FacilityGroup,
    labelKey: 'facilityGroup' as const,
    icon: LucideFolderTree,
    countKey: 'facilityGroup' as const,
  },
];

export const CoreEventsSidebar = () => {
  const t = useTranslations();
  const [selectedType, setSelectedType] = useCoreAggregateTypeFilter();
  const { data: counts, isLoading } = useAtomValue(
    $remoteCoreOutboxEventCounts,
  );

  const totalCount = counts
    ? counts.organization + counts.user + counts.facility + counts.facilityGroup
    : 0;

  return (
    <Col className="@CoreEventsSidebar w-[200px] border-r border-neutral/10 p-3">
      <Loading isLoading={isLoading}>
        <Col gap2>
          <button
            onClick={() => setSelectedType(undefined)}
            className={cn(
              'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
              selectedType === undefined
                ? 'bg-primary/10 text-primary'
                : 'hover:bg-neutral/5',
            )}
          >
            <span>{t.coreEventsView.sidebar.all}</span>
            <span className="text-xs text-neutral/50">{totalCount}</span>
          </button>

          {aggregateTypeConfig.map(
            ({ type, labelKey, icon: Icon, countKey }) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={cn(
                  'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
                  selectedType === type
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-neutral/5',
                )}
              >
                <Row gap2 yCenter>
                  <Icon size={16} className="text-neutral/60" />
                  <span>
                    {t.coreEventsView.sidebar.aggregateTypes[labelKey]}
                  </span>
                </Row>
                <span className="text-xs text-neutral/50">
                  {counts?.[countKey] ?? 0}
                </span>
              </button>
            ),
          )}
        </Col>
      </Loading>
    </Col>
  );
};
